import { store } from "@store/store";

interface PersistArgs {
  key: string;
  expiresInMs?: number;
}

const DEFAULT_EXPIRY_MS = 2 * 60 * 60 * 1000;

export function persistPayloadToStorage(args: PersistArgs) {
  if (typeof window === "undefined") return;
  const { key, expiresInMs = DEFAULT_EXPIRY_MS } = args || ({} as PersistArgs);
  if (!key) return;
  try {
    const payloadData = store?.getState()?.globalState?.payloadData ?? {};
    const now = Date.now();
    localStorage.setItem(
      key,
      JSON.stringify({
        data: payloadData,
        savedAt: now,
        expiresAt: now + expiresInMs
      })
    );
  } catch (err) {
    console.error("persistPayloadToStorage error", err);
  }
}

export function getPersistedPayloadFromStorage(args: { key: string }) {
  if (typeof window === "undefined") return null;
  const { key } = args || ({} as { key: string });
  if (!key) return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { data?: unknown; expiresAt?: number };
    if (!parsed || typeof parsed !== "object") return null;
    if (parsed.expiresAt != null && parsed.expiresAt <= Date.now()) return null;
    return parsed.data ?? null;
  } catch (err) {
    console.error("getPersistedPayloadFromStorage error", err);
    return null;
  }
}
